import { registerPlugin } from "@capacitor/core";
import { isNative } from ".";
import { VehicleInfoIds } from "./carPlugin";

export interface CarDiagPlugin {
  getVehicleInfo(options: {
    infoId: string;
  }): Promise<{ infoId: string; value: string }>;
  disconnect?: () => Promise<void>;
}

export const CarDiag = registerPlugin<CarDiagPlugin>("CarDiag");

export const getVehicleInfo = async (infoId: string) => {
  if (!isNative) {
    throw new Error("仅在原生环境可用");
  }
  const res = await CarDiag.getVehicleInfo({ infoId });
  return res;
};

export const getVIN = async () => {
  const res = await getVehicleInfo(VehicleInfoIds.VEHICLE_VIN_ID);
  return res.value;
};

export default CarDiag;
